module.exports = __webpack_public_path__ + "static/media/transitional_marker_light_blue.56c81a67.svg";